import { DateTime } from 'luxon';
import { firebase } from '@/plugins/firebase';

export async function serverDate() {
  return DateTime.fromSeconds(firebase.firestore.Timestamp.now().seconds);
}

export async function serverUnix() {
  let result = await serverDate();
  return result.toSeconds();
}

export function now() {
  return DateTime.now();
}

export function unix() {
  return now().toSeconds();
}

export function fromDate(date) {
  return DateTime.fromJSDate(date);
}

export function fromUnix(unixTimestamp) {
  return DateTime.fromSeconds(unixTimestamp);
}

export function fromUnixToJSDate(unixTimestamp) {
  return DateTime.fromSeconds(unixTimestamp).toJSDate();
}

export function format(format, date = DateTime.now()) {
  return date.toFormat(format);
}

export function formatJSDate(format, date) {
  return DateTime.fromJSDate(date).toFormat(format);
}

export function addToUnix(value, type, date = DateTime.now()) {
  return date.plus({[type] : value}).toSeconds();
}

export function addToDate(value, type, date = DateTime.now()) {
  return date.plus({[type] : value}).toJSDate();
}

export function subtractToUnix(value, type, date = DateTime.now()) {
  return date.minus({[type] : value}).toSeconds();
}

export function subtractToDate(value, type, date = DateTime.now()) {
  return date.minus({[type] : value}).toJSDate();
}

export function trimJSSeconds(jsdate) {
  if (jsdate) {
    jsdate.setMilliseconds(0);
    jsdate.setSeconds(0);
  }
  return jsdate;
}
